import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const Support = ({ content }) => {
    return content?.bigImage ? (
        <div className={styles.support}>
            <a href={content?.url} target="_blank" rel="noreferrer" className={styles.supportLink}>
                <img className={styles.supportPic} src={content.bigImage} />
            </a>
            <a href={content?.url} target="_blank" rel="noreferrer" className={styles.supportLogo}>
                <div className={styles.supportLogoBox}>
                    <img className={styles.supportLogoIcon} src={content?.smallImage} />
                </div>
                <div className={styles.supportLogoText}>联合出品</div>
            </a>
        </div>
    ) : null;
};

Support.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Support);
